import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { StringUtils } from '@/common/utils/StringUtils';
import { far } from '@awesome.me/kit-b4fd369ea4/icons';
import { useCallback, useEffect, useState } from 'react';

/**
 * FDN-565 (Perspective Adjustments)
 */
export const PerspectiveAdjList = () => {
  const rsrc = useRsrc();
  const { navState } = useNavState();

  const module = useModuleFromRoute();
  const [dimsColDefs, setDimsColDefs] = useState([]);

  const clientSideRowData = useCallback((setDataSource) => {
    const reqParam = {
      entity: 'PERSPECTIVE_ADJ',
      fetchReqParam: navState.fetchReqParam,
      kpi: navState.trxGroup,
      hist: 'false', // TODO: Add History toggle
    };

    const dataPlugin = navState.dataPluginCode ?? 'PERSPECTIVE_ADJ_DATA_PLUGIN';
    rsrc.data(module, dataPlugin, reqParam, 'PERSPECTIVE_ADJ').then((res) => {
      setDataSource(res);
    });
  }, []);

  useEffect(() => {
    const entity = navState.fetchReqParam.entity;
    rsrc.data(module, 'PERSPECTIVE_DEF_DATA_PLUGIN', { entity }, entity).then((res) => {
      const dimCols = Object.values(res.codeToDim).map((dim) => ({
        headerName: dim.displayName,
        field: StringUtils.toLowerCamel(dim.code) + 'Code',
        precedence: 0,
      }));

      setDimsColDefs(dimCols);
    });
  }, [navState]);

  const augFieldDefs = (fieldToFieldDef) => {
    delete fieldToFieldDef.code;

    // Add dimension columns
    for (const dimCol of dimsColDefs) {
      fieldToFieldDef[dimCol.field] = dimCol;
    }
  };

  return (
    dimsColDefs.length > 0 && (
      <>
        <Title icon={far.faSlidersH} title={navState.title} />
        <EntityList
          entity="PERSPECTIVE_ADJ"
          clientSideRowData={clientSideRowData}
          augFieldDefs={augFieldDefs}
          showTitle={false}
        />
      </>
    )
  );
};
